import { useReport } from "../ReportContext";
import { useUser } from "../../UserContext"

const ranges = ["very_low", "low", "medium", "high", "very_high"]

const AccessToFeelingsAssessment = () => {
	const { respondent } = useUser();
	const { reportContent: { acf: { emotions } } } = useReport();

	const accessPercentile = parseInt( respondent?.weqProfile?.percentiles?.feelings_Access / 20, 10);

	return <div className={`assessment-text rating-${ranges[accessPercentile]}`} dangerouslySetInnerHTML={{ __html: emotions.access[ ranges[accessPercentile] ] }} />
}

export default AccessToFeelingsAssessment;